"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeServiceResponse = exports.decodeResponse = void 0;
const micro_errors = __importStar(require("@journeyapps-platform/micro-errors"));
const defs = __importStar(require("../definitions"));
const errors = __importStar(require("./errors"));
const codecs = __importStar(require("./codecs"));
const decodeResponse = async (response, meta) => {
    const content_type = response.headers.get(defs.Header.ContentType) || defs.ContentType.JSON;
    // extract the first part of Content-Type - i.e "[application/json]; charset-utf8"
    const codec = codecs.DEFAULT_CODECS[content_type.replace(/(?!<.*);.*/, '')];
    if (!codec) {
        const raw = await response.text();
        throw new errors.UnparsableServiceResponse(`${meta.method} ${meta.url}`, response.status, raw);
    }
    return codec.decode(await response.arrayBuffer());
};
exports.decodeResponse = decodeResponse;
const decodeServiceResponse = async (response, meta) => {
    const { data, error } = await (0, exports.decodeResponse)(response, meta);
    if (data) {
        return data;
    }
    if (error) {
        throw new micro_errors.JourneyError(error);
    }
    /**
     * Not a JSON response, meaning it's not a standard response or error produced by journey-micro.
     * This typically means something like a 404 or a 503 (gateway error).
     * The body is usually meaningless in these cases.
     * 3xx responses are also unexpected here.
     */
    if (response.status >= 300) {
        throw new errors.UnparsableServiceResponse(`${meta.method} ${meta.url}`, response.status);
    }
    return null;
};
exports.decodeServiceResponse = decodeServiceResponse;
